import * as React from "react";
const SvgReceivables = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={65}
    fill="none"
    {...props}
  >
    <circle cx={33} cy={32.5} r={32.5} fill="#F0FDF9" />
    <path
      fill="#fff"
      fillOpacity={0.01}
      d="M22.167 26.813c0-2.276 0-3.413.443-4.282a4.063 4.063 0 0 1 1.775-1.776c.87-.442 2.007-.442 4.282-.442h8.667c2.275 0 3.412 0 4.281.442a4.062 4.062 0 0 1 1.776 1.776c.443.869.443 2.006.443 4.282v17.875l-3.724-2.709-3.386 2.709L33 41.978l-3.724 2.709-3.385-2.709-3.724 2.709V26.811Z"
    />
    <path
      stroke="#10B981"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m28.938 30.469 2.708 2.708 6.094-6.094m6.094 17.605V26.811c0-2.275 0-3.412-.443-4.281a4.062 4.062 0 0 0-1.776-1.776c-.869-.442-2.006-.442-4.281-.442h-8.667c-2.275 0-3.413 0-4.282.442a4.063 4.063 0 0 0-1.775 1.776c-.443.869-.443 2.006-.443 4.282v17.875l3.724-2.709 3.385 2.709L33 41.978l3.724 2.709 3.386-2.709 3.724 2.709Z"
    />
  </svg>
);
export default SvgReceivables;